import { BodyText, Placeholder, SummaryCard } from '@if/mui'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { StickyNote } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  fundingSummary: FundingSummaryDto
}

const NotesCard = ({ fundingSummary }: Props) => {
  const { t } = useTranslation()

  return (
    <SummaryCard title={t('fundingSummary.notes')} icon={StickyNote}>
      {fundingSummary?.fcfNote ? (
        <BodyText sx={{ whiteSpace: 'pre-wrap' }}>{fundingSummary.fcfNote}</BodyText>
      ) : (
        <Placeholder>{t('fundingSummary.noNotes')}</Placeholder>
      )}
    </SummaryCard>
  )
}

export default NotesCard
